$(".top-mainBanners").slick({
  arrows: false,
  centerMode: true,
  centerPadding: "60px",
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        centerMode: false,
        slidesToShow: 1,
      },
    },
  ],
});

$(".jounal-list").slick({
  arrows: false,
  centerMode: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        // dots: true,
        // dotsClass: "slide-dots",
        centerMode: true,
        centerPadding: "20px",
        slidesToShow: 1,
      },
    },
  ],
});

$(".cannabinoid-list").slick({
  arrows: false,
  centerMode: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        // dots: true,
        // dotsClass: "slide-dots",
        centerMode: true,
        centerPadding: "20px",
        slidesToShow: 1,
      },
    },
  ],
});
